import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NumericCalculatorService } from './core/services';
import { GPA, GradeType } from './domain';
import { EditGradeService } from './core/services/edit-grade.service';
import { IonicModule } from '@ionic/angular';
import { NumericGpaPage } from './pages/numeric-gpa/numeric-gpa.page';
import { NonNumericPage } from './pages/non-numeric/non-numeric.page';
import { SummaryComponent } from './shared/components/summary/summary.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { GpaTypeComponent } from './shared/components/gpa-type/gpa-type.component';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
  imports: [IonicModule, HeaderComponent, FooterComponent, GpaTypeComponent, NumericGpaPage, NonNumericPage, SummaryComponent]
})
export class AppComponent {
  gpaType: string;
  calculateSummary = false;
  readonly gradeTypes = GradeType;
  gpa: GPA;
  editButtonPressed: boolean;
  constructor(
    private _calculator: NumericCalculatorService,
    public editGradeService: EditGradeService
  ) {
    this.initializeGoogleAnalytics();
  }

  setType(type: string): void {
    this.editGradeService.reset();
    this.editGradeService.setGpaType(type);
    this.gpaType = type;
    this.gpa = this.editGradeService.gpaGrades;
    this.editButtonPressed = this.editGradeService.editButtonPressed;
  }

  showSummary(show: boolean): void {
    this.calculateSummary = show;
  }

  resetTypeField(): void {
    this.calculateSummary = false;
    this.editGradeService.reset();
    this.gpaType = this.editGradeService.gpaType;
    this.editButtonPressed = this.editGradeService.editButtonPressed;
  }

  editGrades(): void {
    this.calculateSummary = false;
    this.editGradeService.setEditButtonPressed(true);
    this.editButtonPressed = this.editGradeService.editButtonPressed;
  }

  selectedGrades(gpa: GPA): void {
    this.gpa = gpa;
    this.gpa.finalGpa = this._calculator.calculate(
      gpa.exgpa,
      gpa.minPass,
      gpa.maxPass,
      gpa.minA ? gpa.minA : 0,
      gpa.minB ? gpa.minB : 0,
      gpa.knownInstitute
    );
    this.editGradeService.setGpaGrades(gpa);
  }

  /**
   * Loads Google Analytics scripts. See https://developers.google.com/tag-manager/quickstart
   */
  initializeGoogleAnalytics(): void {
    if (environment.googleTagId && environment.googleTagId !== '') {
      // Load Google Tag Manager script
      const gtmScript = document.createElement('script');
      gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${environment.googleTagId}');
    `;

      document.head.appendChild(gtmScript);

      // Start tracking users
      const gtmIframe = document.createElement('iframe');
      gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${environment.googleTagId}`;
      gtmIframe.height = '0';
      gtmIframe.width = '0';
      gtmIframe.style.display = 'none';
      gtmIframe.style.visibility = 'hidden';

      document.body.appendChild(gtmIframe);
      console.info('Google Analytics set up and loaded');
    } else {
      console.info('Google Analytics not set up');
    }
  }
}
